/** Build readable, durable article paths. The ID is authoritative; the slug is
 * for people and may safely change when an article title is edited. */
export function articleSlug(title: string): string {
  const slug = title
    .normalize("NFKD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .trim()
    .replace(/[’']/g, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");

  return slug || "post";
}

export function articlePath(article: { _id?: string; title: string }): string {
  if (!article._id) return "/";
  return `/posts/${article._id}/${articleSlug(article.title)}`;
}
